import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IError } from "../../../interfaces/base";
import {
  IGetTrainerPayload,
  ITrainerState,
  ICreateTrainerPayload,
  IUpdateTrainerPayload,
} from "../../../interfaces/store/trainer-interfaces";

const initialState: ITrainerState = {
  trainer: null,
  error: null,
  loading: false,
  requestState: "prepare",
  operation: null,
};

const _getTrainerStart = (
  state: ITrainerState,
  { payload }: PayloadAction<IGetTrainerPayload>
) => {
  state.loading = true;
  state.error = null;
  state.requestState = "start";
  state.operation = "read";
};

const _getTrainerSuccess = (
  state: ITrainerState,
  { payload }: PayloadAction<any>
) => {
  state.trainer = payload.data;
  state.loading = false;
  state.error = null;
  state.requestState = "finish";
};

const _getTrainerFailed = (
  state: ITrainerState,
  { payload }: PayloadAction<IError>
) => {
  state.loading = false;
  state.error = payload;
  state.requestState = "error";
};

const _resetTrainer = (state: ITrainerState) => {
  state.trainer = null;
  state.error = null;
  state.loading = false;
  state.requestState = "prepare";
  state.operation = null;
};

const _createTrainerStart = (
  state: ITrainerState,
  { payload }: PayloadAction<ICreateTrainerPayload>
) => {
  state.loading = true;
  state.error = null;
  state.requestState = "start";
  state.operation = "create";
};

const _createTrainerSuccess = (
  state: ITrainerState,
  { payload }: PayloadAction<any>
) => {
  state.trainer = payload;
  state.loading = false;
  state.error = null;
  state.requestState = "finish";
};

const _createTrainerFailed = (
  state: ITrainerState,
  { payload }: PayloadAction<IError>
) => {
  state.loading = false;
  state.error = payload;
  state.trainer = null;
  state.requestState = "error";
};

const _updateTrainerStart = (
  state: ITrainerState,
  { payload }: PayloadAction<IUpdateTrainerPayload>
) => {
  state.loading = true;
  state.error = null;
  state.requestState = "start";
  state.operation = "update";
};

const _updateTrainerSuccess = (
  state: ITrainerState,
  { payload }: PayloadAction<any>
) => {
  state.trainer = payload;
  state.loading = false;
  state.error = null;
  state.requestState = "finish";
};

const _updateTrainerFailed = (
  state: ITrainerState,
  { payload }: PayloadAction<IError>
) => {
  state.loading = false;
  state.error = payload;
  state.trainer = null;
  state.requestState = "error";
};

const TrainerSlice = createSlice({
  name: "trainer",
  initialState,
  reducers: {
    getTrainerStart: _getTrainerStart,
    getTrainerSuccess: _getTrainerSuccess,
    getTrainerFailed: _getTrainerFailed,
    resetTrainer: _resetTrainer,
    createTrainerStart: _createTrainerStart,
    createTrainerSuccess: _createTrainerSuccess,
    createTrainerFailed: _createTrainerFailed,
    updateTrainerStart: _updateTrainerStart,
    updateTrainerSuccess: _updateTrainerSuccess,
    updateTrainerFailed: _updateTrainerFailed,
  },
});

export const {
  getTrainerStart,
  getTrainerSuccess,
  getTrainerFailed,
  resetTrainer,
  createTrainerStart,
  createTrainerSuccess,
  createTrainerFailed,
  updateTrainerStart,
  updateTrainerSuccess,
  updateTrainerFailed,
} = TrainerSlice.actions;
export default TrainerSlice.reducer;
